import type { GridColumns } from "@mui/x-data-grid-premium";

export const useColumns = (): GridColumns => [
    {
        field: 'transactionId',
        headerName: 'Transaction ID'
    },
    {
        field: 'xCorrelationId',
        headerName: 'X-Correlation ID'
    },
    {
        field: 'xOperationId',
        headerName: 'X-Operation ID'
    },
    {
        field: 'xRequestId',
        headerName: 'X-Request ID'
    },
    {
        field: 'resultStatus',
        headerName: 'Result Status'
    },
    {
        field: 'createdDateTime',
        headerName: 'Created Date Time'
    },
    {
        field: 'hCreatedDateTime',
        headerName: 'H-Created Date Time'
    }
]
    .map(column => ({
        ...column,
        minWidth: 200,
        align: 'center',
        flex: 1,
        headerAlign: 'center',
        disableColumnMenu: true,
        sortable: false,
        disableExport: true,
        disableReorder: true,
    }));

export default useColumns;
